// TODO: Remove the belong line
// should add error reporting service

/* istanbul ignore next */
export const reportError = (error) =>
  process.env.NODE_ENV !== 'test' && console.error(error); // eslint-disable-line no-console
